export const stateTaxMasterSetupType = {
  FETCH_STATE_DATA_START: 'FETCH_STATE_DATA_START',
  FETCH_STATE_DATA_SUCCESS: 'FETCH_STATE_DATA_SUCCESS',
  FETCH_STATE_DATA_FAILED: 'FETCH_STATE_DATA_FAILED',
  TOGGLE_STATE_TAX_INCLUDED_FLAG_START: 'TOGGLE_STATE_TAX_INCLUDED_FLAG_START',
  TOGGLE_STATE_TAX_INCLUDED_FLAG_FAILED: 'TOGGLE_STATE_TAX_INCLUDED_FLAG_FAILED',
  TOGGLE_STATE_TAX_INCLUDED_FLAG_SUCCESS: 'TOGGLE_STATE_TAX_INCLUDED_FLAG_SUCCESS',
  HIDE_ALERT: 'HIDE_ALERT',
};
